import "../../../css/masonry-layout.scss";
import MiniMasonry from "minimasonry";
import { useEffect, useState } from "react";
import NewsPost from "../../news/news-post";
import ContentBlock from "./content-block";
import InfographicBlock from "./infographic-block";
import SocialPost from "./social-post";

const MasonryBlocks = function ({
  pageBlockGroup: { title, masonryBlocks },
  section,
}) {
  const [masonry, setMasonry] = useState(null);
  const [masonryLoadedClass, setMasonryLoadedClass] = useState("");

  // Setup Masonry
  useEffect(() => {
    setMasonry(
      new MiniMasonry({
        container: ".masonry-layout",
        gutter: 25,
        ultimateGutter: 25,
        baseWidth: 320,
      })
    );
    refreshLayout();
  }, []);

  // Refresh Layout
  function refreshLayout() {
    masonry?.layout();
    setTimeout(() => {
      masonry?.layout();
      setMasonryLoadedClass("masonry-layout--loaded");
    }, 4);
    setTimeout(() => {
      masonry?.layout();
    }, 10);
  }

  const map = new Map();
  map.set("newsPostReference", NewsPost);
  map.set("contentBlock", ContentBlock);
  map.set("infographicBlock", InfographicBlock);
  map.set("socialPostReference", SocialPost);

  return (
    <div className="masonry-blocks bg-gradient">
      <div className="max-w-7xl mx-auto py-10 md:py-16">
        <div className={`masonry-layout ${masonryLoadedClass}`}>
          {masonryBlocks?.map((block, index) => {
            const Component = map.get(block._type);
            let data = block;

            // News Post Modifier
            if (block._type === "newsPostReference") {
              data.post = block.newsPost;
              data.section = section;
            }

            // Social Post Modifier
            if (block._type === "socialPostReference") {
              data.post = block.socialPost;
              data.refreshLayout = refreshLayout;
            }

            return <Component key={index} {...data} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default MasonryBlocks;
